export default __webpack_public_path__ + "static/media/nft_calendar_logo_vector_optimized.31602455.svg";